import { useState, useEffect } from "react";
import "./Menu.scss";
import {
  MAIN_MENU,
  SUSTAINABILITY_23,
  SUSTAINABILITY_24,
  SUSTAINABILITY_25,
} from "../MenuList";
import { useNavigate, useLocation } from "react-router-dom";

const iconPath = process.env.PUBLIC_URL + "/assets/docs/";
const iconPathImg = process.env.PUBLIC_URL + "/assets/images/";

export default function Menu() {
  const navigate = useNavigate();
  const [show, setShow] = useState(true);
  const location = useLocation();
  const [listOfMenu, setListOfMenu] = useState(MAIN_MENU);

  useEffect(() => {
    if (
      location.pathname == "/sustainability-23" ||
      location.pathname == "/event-agenda-23" ||
      location.pathname == "/support-23"
    ) {
      setListOfMenu(SUSTAINABILITY_23);
    } else if (
      location.pathname == "/sustainability-24" ||
      location.pathname == "/support-24"
    ) {
      setListOfMenu(SUSTAINABILITY_24);
    } else if (
      location.pathname == "/sustainability-25" ||
      location.pathname == "/support-25"
    ) {
      setListOfMenu(SUSTAINABILITY_25);
    } else {
      setListOfMenu(MAIN_MENU);
    }
  }, [location.pathname]);

  const navigateTo = (path, e) => {
    if (path !== "") {
      setShow(false);
    }

    if (path !== location && path !== "") {
      navigate(path);
    }
  };

  return (
    <div className="menu">
      <nav>
        <div class="navbar">
          <div class="nav-links">
            <div class="sidebar-logo"></div>
            <ul class="links">
              {listOfMenu.map((links, index) => (
                <li>
                  <a
                    target="new"
                    href={
                      links.link !== ""
                        ? links.link.startsWith("http")
                          ? links.link
                          : iconPath + links.link
                        : undefined
                    }
                    class="primary-link"
                    onMouseOver={() => {
                      setShow(true);
                    }}
                    onClick={(e) =>
                      links.path != "" && navigateTo(links.path, e)
                    }
                  >
                    {links["title"]}
                  </a>

                  {links["subMenu"] && show && (
                    <ul className="htmlCss-sub-menu sub-menu">
                      {links["subMenu"].map((subLinks) => (
                        <li class="more">
                          <a
                            onClick={(e) => navigateTo(subLinks.path, e)}
                            className="submenu-link"
                          >
                            <span class="sub-menu-title">
                              {subLinks["title"]}
                            </span>
                            {(subLinks["title"] == "Legal and Compliance" ||
                              subLinks["title"] ==
                                "Sustainability Dialogue India") && (
                              <div>
                                {" "}
                                <img
                                  className="arrow-img"
                                  src={`${iconPathImg}common/arrow_right.png`}
                                  alt="img"
                                />
                                <img
                                  className="arrow-img-hover"
                                  src={`${iconPathImg}common/arrow_right_hover.png`}
                                  alt="img"
                                />
                              </div>
                            )}
                          </a>
                          {subLinks["subMenu"] &&
                            subLinks["title"] == "Legal and Compliance" && (
                              <ul class="more-sub-menu sub-menu">
                                {subLinks["subMenu"].map((subLinksMenu) => (
                                  <li>
                                    <a
                                      target="new"
                                      href={`${
                                        subLinksMenu.link !== ""
                                          ? iconPath + subLinksMenu.link
                                          : subLinksMenu.path
                                      }`}
                                      className="sub-menu-link"
                                    >
                                      <span class="sub-menu-sub">
                                        {subLinksMenu["title"]}
                                      </span>
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            )}
                          {subLinks["subMenu"] &&
                            subLinks["title"] ==
                              "Sustainability Dialogue India" && (
                              <ul class="more-sub-menu sub-menu">
                                {subLinks["subMenu"].map((subLinksMenu) => (
                                  <li>
                                    <a
                                      target="new"
                                      onClick={(e) =>
                                        navigateTo(subLinksMenu.path, e)
                                      }
                                      className="sub-menu-link"
                                    >
                                      <span class="sub-menu-sub">
                                        {subLinksMenu["title"]}
                                      </span>
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            )}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
